import { Pipe, PipeTransform } from '@angular/core';


@Pipe({ name: 'startsWith' })
export class startsWithPipe implements PipeTransform {
  transform(value: any[], term: string): any[] {
    if (!term) {
      return value;
    }
    if (value.length != 0 && term !== '') {
      return value.filter((x: any) => x.org_name.toLowerCase().includes(term.toLowerCase()) ||
        x.org_id.toLowerCase().includes(term.toLowerCase()) ||
        x.requisition_no.toLowerCase().includes(term.toLowerCase()) ||
        x.reqq.toLowerCase().includes(term.toLowerCase()) ||
        x.requisition_date.toLowerCase().includes(term.toLowerCase()) ||
        x.job_desc.toLowerCase().includes(term.toLowerCase()) ||
        x.no_personnel.toLowerCase().includes(term.toLowerCase()) ||
        x.filled_personnel.toLowerCase().includes(term.toLowerCase()) ||
        x.start_date.toLowerCase().includes(term.toLowerCase()) ||
        x.no_days.toLowerCase().includes(term.toLowerCase()) ||
        x.req_note.toLowerCase().includes(term.toLowerCase())
      )
    } else {

      return value;
    }


  }
}


// WEBPACK FOOTER //
// ./src/app/customstart.pipes.ts